var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-client-table',{attrs:{"data":_vm.tableData,"columns":_vm.columns,"options":_vm.options}},[_c('spring-spinner',{staticClass:"spinner",attrs:{"slot":"loading","animation-duration":2500,"size":70,"color":"#4ae387"},slot:"loading"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }